
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"#fff","viewBox":"0 0 30 30"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M22.492 10.07a1.217 1.217 0 00-1.722-.047l-7.762 7.364-3.703-3.801a1.217 1.217 0 10-1.742 1.695l4.539 4.66a1.21 1.21 0 001.707.036l8.636-8.188a1.216 1.216 0 00.047-1.719zm0 0"}}),_c('path',{attrs:{"d":"M15 0C6.73 0 0 6.73 0 15s6.73 15 15 15 15-6.73 15-15S23.27 0 15 0zm0 27.566C8.07 27.566 2.434 21.93 2.434 15 2.434 8.07 8.07 2.434 15 2.434c6.93 0 12.566 5.636 12.566 12.566 0 6.93-5.636 12.566-12.566 12.566zm0 0"}})])
          )
        }
      }
    